import { render } from "./FormularioVida.vue?vue&type=template&id=c0a5e1da"
import script from "./FormularioVida.vue?vue&type=script&lang=js"
export * from "./FormularioVida.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__